var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    class: {
      open: _vm.visible
    },
    attrs: {
      "no-body": ""
    },
    on: {
      "mouseenter": _vm.collapseOpen,
      "mouseleave": _vm.collapseClose
    }
  }, [_c('b-card-header', {
    staticClass: "px-0 py-0",
    class: {
      collapsed: !_vm.visible,
      'bg-light-warning': _vm.selectedTrip && _vm.selectedTrip.id === _vm.item.id || _vm.visible
    },
    attrs: {
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": _vm.collapseItemID,
      "role": "tab",
      "data-toggle": "collapseflight"
    },
    on: {
      "click": function click($event) {
        return _vm.updateVisible(!_vm.visible);
      }
    }
  }, [_c('b-row', {
    class: "w-100 d-flex justify-content-around flex-lg-nowrap",
    staticStyle: {
      "max-height": "55px"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    staticClass: "d-flex-center",
    attrs: {
      "cols": "2",
      "md": "1"
    }
  }, [_c('div', {
    staticClass: "d-flex-center"
  }, [_c('IAmLogoAirline', {
    attrs: {
      "airline": _vm.item.segments[0].operating === 'BL' ? _vm.item.segments[0].operating : _vm.item.airline.split(' | ')[0] || _vm.item.operator,
      "height": 40
    }
  })], 1)]), _c('b-col', {
    staticClass: "d-flex flex-column justify-content-center align-items-center",
    attrs: {
      "cols": "1",
      "xl": "1"
    }
  }, [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.html.v-primary",
      modifiers: {
        "hover": true,
        "html": true,
        "v-primary": true
      }
    }],
    staticClass: "font-weight-bolder align-center",
    attrs: {
      "title": _vm.item.segments.map(function (item) {
        return _vm.resolveAirlineFlightNumber(item.airline, item.flightNumber);
      }).join(' | ')
    }
  }, [_c('span', {
    staticClass: "text-airline text-nowrap fw-700",
    class: _vm.isMobileView ? '' : 'font-medium-2'
  }, [_vm._v(" " + _vm._s(_vm.resolveAirlineFlightNumber(_vm.item.segments[0].airline, _vm.item.segments[0].flightNumber)) + " ")])]), _vm.isMobileView ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.html.v-primary",
      modifiers: {
        "hover": true,
        "html": true,
        "v-primary": true
      }
    }],
    staticClass: "text-nowrap text-body fw-700",
    attrs: {
      "title": _vm.getAirCraftByIata(_vm.item.segments[0].airCraft) || _vm.item.segments[0].airCraft
    }
  }, [_vm._v(" " + _vm._s(_vm.convertShortenAircraft(_vm.item.segments[0].airCraft)) + " ")])]) : _vm._e()]), _c('b-col', {
    staticClass: "d-none d-md-flex align-items-center justify-content-center text-black text-center",
    attrs: {
      "md": "2"
    }
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.html.v-primary.top.window",
      modifiers: {
        "hover": true,
        "html": true,
        "v-primary": true,
        "top": true,
        "window": true
      }
    }],
    class: ['xs'].includes(_vm.appBreakPoint) ? 'font-small-1' : 'font-medium-1 text-nowrap',
    attrs: {
      "title": "".concat(_vm.$t('flight.totalDuration'), ": ").concat(_vm.toHoursAndMinutes(_vm.item.duration))
    }
  }, [_vm._v(" " + _vm._s("".concat(_vm.convertISODateTime(_vm.item.departure.at, _vm.item.departure.timezone).time, " - ").concat(_vm.convertISODateTime(_vm.item.arrival.at, _vm.item.arrival.timezone).time)) + " ")])]), _c('b-col', {
    staticClass: "text-center d-flex flex-column justify-content-center align-items-center",
    class: _vm.isMobileView ? '' : 'font-medium-2',
    attrs: {
      "cols": "5",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "text-nowrap"
  }, _vm._l(_vm.getTripNameBySegments(_vm.item), function (point, pointIndex) {
    return _c('span', {
      key: pointIndex
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.html.v-primary.top.window",
        modifiers: {
          "hover": true,
          "html": true,
          "v-primary": true,
          "top": true,
          "window": true
        }
      }],
      class: pointIndex !== 0 && pointIndex !== _vm.getTripNameBySegments(_vm.item).length - 1 ? "font-weight-light ".concat(_vm.isMobileView ? 'font-small-2' : 'font-medium-1') : 'fw-700',
      attrs: {
        "title": _vm.isMobileView ? '' : "<div>".concat(pointIndex !== 0 && pointIndex !== _vm.getTripNameBySegments(_vm.item).length - 1 ? 'Điểm dừng:' : '', " ").concat(point.name, "</div>\n                  ").concat(point.transitTime ? "<div>".concat(_vm.$t('ticket.flightsInfo.transitTime'), ": ").concat(point.transitTime, "</div>") : '')
      }
    }, [_vm._v(" " + _vm._s(point.iataCode) + " ")]), pointIndex !== _vm.getTripNameBySegments(_vm.item).length - 1 ? _c('span', [_vm._v(" - ")]) : _vm._e()]);
  }), 0), _vm.isMobileView ? _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s("".concat(_vm.convertISODateTime(_vm.item.departure.at, _vm.item.departure.timezone).time, " - ").concat(_vm.convertISODateTime(_vm.item.arrival.at, _vm.item.arrival.timezone).time)) + " ")]) : _vm._e()]), _c('b-col', {
    staticClass: "d-none d-md-flex align-items-center",
    attrs: {
      "cols": "1"
    }
  }, [_c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.html.v-primary",
      modifiers: {
        "hover": true,
        "html": true,
        "v-primary": true
      }
    }],
    staticClass: "text-nowrap font-weight-bold",
    class: _vm.isMobileView ? '' : 'font-medium-2',
    attrs: {
      "title": _vm.getAirCraftByIata(_vm.item.segments[0].airCraft) || _vm.item.segments[0].airCraft
    }
  }, [_vm._v(" " + _vm._s(_vm.convertShortenAircraft(_vm.item.segments[0].airCraft)) + " ")])]), ['VJ'].includes(_vm.item.source) ? _c('b-col', {
    staticClass: "d-flex flex-column align-items-start justify-content-center",
    attrs: {
      "cols": "2"
    }
  }, [_vm.item.fareOptions.every(function (item) {
    return item.seatAvailable === 0;
  }) ? _c('BBadge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.full')) + " ")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('b-collapse', {
    attrs: {
      "id": _vm.collapseItemID,
      "accordion": _vm.accordion,
      "role": "tabpanel"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('b-card-body', [_vm._t("default")], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }